import { useStyletron } from "baseui";
import { defaultTo } from "lodash";
import React from "react";

/**
 * Boost this section in the Algolia search results ranking by the given boost integer
 * Renders nothing on screen, is just metadata
 **/
export const SearchBoost = (props: { boost?: number }) => {
  const [css] = useStyletron();
  return (
    <div
      aria-hidden="true"
      className={css({ display: "none" })}
      data-docscontent="true"
      data-searchboost={String(defaultTo(props.boost, 1))}
    />
  );
};
